import { formatDataverseRecordKey } from '../lib/dataverseRecordId';

const ENTITY_SET = 'oc_driftinnstillings';
const SELECT = 'oc_driftinnstillingid,oc_name,oc_allowblaalysoverride,statecode';

function mapRecord(record) {
  if (!record) {
    return null;
  }
  return {
    id: record.oc_driftinnstillingid,
    name: record.oc_name || 'Drift',
    allowBlaalysOverride: Boolean(record.oc_allowblaalysoverride)
  };
}

/**
 * Municipality-wide operations settings (singleton row in oc_driftinnstilling).
 */
export function createOperationsSettingsService(dataverseApiCall) {
  const getOrCreate = async () => {
    const response = await dataverseApiCall(
      `/${ENTITY_SET}?$select=${SELECT}&$filter=statecode eq 0&$top=1`
    );
    const existing = response?.value?.[0];
    if (existing) {
      return mapRecord(existing);
    }

    // Environments without a seeded row: create with default true (matches app setting).
    const created = await dataverseApiCall(`/${ENTITY_SET}`, {
      method: 'POST',
      headers: { Prefer: 'return=representation' },
      body: JSON.stringify({
        oc_name: 'Drift',
        oc_allowblaalysoverride: true
      })
    });
    if (created?.oc_driftinnstillingid) {
      return mapRecord(created);
    }

    const afterCreate = await dataverseApiCall(
      `/${ENTITY_SET}?$select=${SELECT}&$filter=statecode eq 0&$top=1`
    );
    return mapRecord(afterCreate?.value?.[0]);
  };

  return {
    get: async () => {
      try {
        return await getOrCreate();
      } catch (error) {
        // Table missing in municipality env — treat as unknown / off for UI.
        console.warn('Could not load oc_driftinnstilling:', error);
        return null;
      }
    },

    setAllowBlaalysOverride: async (enabled) => {
      const current = await getOrCreate();
      if (!current?.id) {
        throw new Error('Fant ingen driftsinnstilling å oppdatere.');
      }

      await dataverseApiCall(`/${ENTITY_SET}(${formatDataverseRecordKey(current.id)})`, {
        method: 'PATCH',
        body: JSON.stringify({
          oc_allowblaalysoverride: Boolean(enabled)
        })
      });

      return {
        ...current,
        allowBlaalysOverride: Boolean(enabled)
      };
    }
  };
}
